module.exports = __webpack_public_path__ + "media/images/athletes/2813-2a5a13ada27027027641cd1b098f751d.png";